import React from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import NavbarLogo from "../../asset/icon/navbar-logo.png";
// import MainLogo from "../images/sos_logo.png";
import InstagramLogoLarge from "../../asset/icon/instagram-logo-new.png";
import TwitterLogoLarge from "../../asset/icon/twitter-logo-new.png";
import FacebookLogoLarge from "../../asset/icon/facebook-logo-new.png";
import linkedin from "../../asset/icon/linkedin.png";
import youtube from "../../asset/icon/youtube.png";
import newlogo from "../../image/logo/Logo.png";
import TopBar from "../TopMenu/Topbar";

import "./NewNavbar.css";

const NewNavbar = (props) => {
  const { handleClick } = props;
  const [navbarHide, setNavbarHide] = useState(true);
  const handleKnowMore = () => {
    handleClick();
  };

  const toggleNavbar = () => {
    console.log("toggleNavbar");
    setNavbarHide(!navbarHide);
  };

  return (
    <>    
    <div className="topmenucontainer">
    <TopBar />
    </div>
    <div className="navbarwrapper">
      <div className="topheader d-none d-md-block mb-0">
      <div className="topheaderleft"><Link to="/" className="navbarItem"><img className="" src={newlogo} alt="" /></Link></div>
      <div className="topheaderright"><h1>HGS PALLA (NUH)</h1></div>
      </div>   
      <div className="navbarContainer">
        <div data-aos="fade" className="navbarLarge">
          {/* <Link to="/home" className="h-14">
          <img className="h-full" src={MainLogo} alt="SOS" />
        </Link> */}
          <div
            className="d-flex d-lg-none justify-content-center align-items-center"
            onClick={toggleNavbar}
          >
            <img className="mobile-top-logo d-block d-md-none" src={newlogo} alt="" />
            <h6 className="d-block d-md-none">
              HGS PALLA (NUH)
            </h6>
            <div className="mobileToggleIcon">
              <img className="h-100" src={NavbarLogo} alt="" />
            </div>
          </div>
          <div className="navbarItems">
            <Link to="/" className="navbarItem">
              Home
            </Link>
            <span>|</span>
            <Link to="/mandatory-disclosures" className="navbarItem">
              Mandatory Disclosure
            </Link>
            <span>|</span>
            <p onClick={handleKnowMore} className="navbarItem mb-0 ">
              Know More
            </p>
            <span>|</span>
            <Link to="/gallery" className="navbarItem">
              Gallery
            </Link>
            <span>|</span>
            <Link to="/contact-us" className="navbarItem">
              Contact Us
            </Link>
            <span>|</span>
            <div class="login-wrapper">

            <p className="navbarItem mb-0 login ">
              Login
            </p>
            <div className="loginmenu">
              <Link to="/parent-login" className="navbarItem">
                Parent Login
              </Link>
              <br />
              <Link to="/student-login" className="navbarItem">
                Students Login
              </Link>
              <br />
              <Link to="/Fees-payment" className="navbarItem">
                Fees-Payment
              </Link>            
            </div>
            </div>
            <span>|</span>
            <Link to="/book-tour" className="navbarItem">
              Book a Tour
            </Link>
            <span>|</span>
            <div className="d-flex">
              <div className="socialIconLarge d-flex">
                <img
                  className="h-100"
                  src={FacebookLogoLarge}
                  alt=""
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/soshgspalla",
                      "_blank"
                    )
                  }
                />
              </div>
              {/* <div className="socialIconLarge d-flex">
                                <img
                                    className="h-100"
                                    src={InstagramLogoLarge}
                                    alt=""
                                    onClick={() =>
                                        window.open(
                                            "https://www.instagram.com/hgsfaridabad/",
                                            "_blank"
                                        )
                                    }
                                />
                            </div>
                            <div className="socialIconLarge d-flex">
                                <img
                                    className="h-100"
                                    src={TwitterLogoLarge}
                                    alt=""
                                    onClick={() =>
                                        window.open(
                                            "https://twitter.com/HGS_Faridabad",
                                            "_blank"
                                        )
                                    }
                                />
                            </div> */}
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          "navbarSmall" + (navbarHide ? " custom-right-full" : " end-0")
        }
      >
        <div className="mobileToggle" onClick={toggleNavbar}></div>
        <div className="navMobileItems">
          <Link to="/" className="navMobileItem" onClick={toggleNavbar}>
            Home
          </Link>
          <Link
            to="/mandatory-disclosures"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Mandatory Disclosure
          </Link>
          <Link
            to="/parent-login"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Parent Login
          </Link>
          <p onClick={handleKnowMore} className="navMobileItem">
            Know More
          </p>
          <Link
            to="/contact-us"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Contact Us
          </Link>
          <Link
            to="/book-tour"
            className="navMobileItem"
            onClick={toggleNavbar}
          >
            Book a Tour
          </Link>
          <div className="mobileSocialContainer">
            <div className="mobileSocialIcon">
              <img
                className="h-100"
                src={FacebookLogoLarge}
                alt=""
                onClick={() =>
                  window.open("https://www.facebook.com/soshgspalla", "_blank")
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="margin8"></div>
    </>
  );
};

export default NewNavbar;
